import type { ProductCardSize } from '@/components/shared/product-card/product-card.model'
import type { Product } from '@/schemas/product.schema'

export interface CatalogGridModelProps {
  products: Product[]
}

const HERO_CYCLE_LENGTH = 6

interface CatalogGridCard {
  product: Product
  size: ProductCardSize
}

export function useCatalogGridModel({ products }: CatalogGridModelProps) {
  const cards: CatalogGridCard[] = products.map((product, index) => ({
    product,
    size: index % HERO_CYCLE_LENGTH === 0 ? 'hero' : 'regular',
  }))

  return { cards }
}
